import { render } from "./DocumentOverviewRow.vue?vue&type=template&id=24ad06b8&scoped=true"
import script from "./DocumentOverviewRow.vue?vue&type=script&lang=js"
export * from "./DocumentOverviewRow.vue?vue&type=script&lang=js"

import "./DocumentOverviewRow.vue?vue&type=style&index=0&id=24ad06b8&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24ad06b8"]])

export default __exports__